import {
  TableCell,
  TableHeader,
  TanStackTableRoot,
} from '@toggle/design-system';
import styled from 'styled-components';

export const RankWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
`;

export const StyledTableHeader = styled(TableHeader)`
  position: sticky;
  left: 0;
  top: 0;
  border-bottom: 1px solid var(--border-default);
  z-index: var(--z-index-header-cell);
`;

export const FooterRow = styled(TableCell)`
  padding: 20px 0 0 0;
`;

export const StyledTanStackTableRoot = styled(TanStackTableRoot)`
  tr:last-child td {
    cursor: default;
    &:hover {
      background-color: var(--background-default);
    }
  }
  tr:nth-last-child(-n + 2) td {
    border-bottom: none;
  }
`;
